// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.signing.LeaseSigningWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CancelSigningRequestDto, SendForOfflineSigningRequestDto, SendForOnlineSigningRequestDto } from '../..';

export const LeaseSigningWebApiHandler_cancelSigning_Path = '/api/web/v1/signing/cancelSigning';

/**
 * cancels signing for a lease that is currently in a signing state
 */
export const LeaseSigningWebApiHandler_cancelSigning = (postData: CancelSigningRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, CancelSigningRequestDto, void>(
    {
      endpoint: LeaseSigningWebApiHandler_cancelSigning_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseSigningWebApiHandler_sendForOfflineSigning_Path = '/api/web/v1/signing/sendForOfflineSigning';

/**
 * sends the lease for offline signing
 */
export const LeaseSigningWebApiHandler_sendForOfflineSigning = (
  postData: SendForOfflineSigningRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendForOfflineSigningRequestDto, void>(
    {
      endpoint: LeaseSigningWebApiHandler_sendForOfflineSigning_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseSigningWebApiHandler_sendForOnlineSigning_Path = '/api/web/v1/signing/sendForOnlineSigning';

/**
 * transitions the lease into the sent for online signing state and sends appropriate emails
 */
export const LeaseSigningWebApiHandler_sendForOnlineSigning = (
  postData: SendForOnlineSigningRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendForOnlineSigningRequestDto, void>(
    {
      endpoint: LeaseSigningWebApiHandler_sendForOnlineSigning_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
